"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ramda = require("ramda");

var _classnames = _interopRequireDefault(require("classnames"));

var _MarketplaceProductSkeleton = _interopRequireDefault(require("../MarketplaceProduct/MarketplaceProductSkeleton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    wrapper: {
      gap: spacing(2.5)
    }
  };
});
/**
 * Marketplace products list wrapper.
 *
 * @param {object} props
 * @param {boolean} props.isLoading
 * @param {IProduct[]} props.products
 * @param {function (IProduct): void} props.renderItem
 * @param {BoxProps} props.wrapperProps
 * @param {IMarketplaceProductSkeletonProps} props.skeletonProps
 * @param {function(): void} props.renderFakeItem
 * @param {function(): void} props.renderFakeProduct
 * @param {number} props.fakeItemsCount
 *
 * @returns {ReactElement}
 */

var MarketplaceProductsList = function MarketplaceProductsList(_ref2) {
  var isLoading = _ref2.isLoading,
      products = _ref2.products,
      renderItem = _ref2.renderItem,
      _ref2$wrapperProps = _ref2.wrapperProps,
      wrapperProps = _ref2$wrapperProps === void 0 ? {} : _ref2$wrapperProps,
      _ref2$skeletonProps = _ref2.skeletonProps,
      skeletonProps = _ref2$skeletonProps === void 0 ? {} : _ref2$skeletonProps,
      renderFakeItem = _ref2.renderFakeItem,
      _ref2$renderFakeProdu = _ref2.renderFakeProduct,
      renderFakeProduct = _ref2$renderFakeProdu === void 0 ? function (_ref3) {
    var id = _ref3.id,
        otherProps = (0, _objectWithoutProperties2["default"])(_ref3, ["id"]);
    return /*#__PURE__*/_react["default"].createElement(_MarketplaceProductSkeleton["default"], (0, _extends2["default"])({
      id: id,
      key: id
    }, otherProps));
  } : _ref2$renderFakeProdu,
      _ref2$fakeItemsCount = _ref2.fakeItemsCount,
      fakeItemsCount = _ref2$fakeItemsCount === void 0 ? 12 : _ref2$fakeItemsCount;
  var fakeProducts = (0, _react.useMemo)(function () {
    return (0, _ramda.range)(1, fakeItemsCount + 1);
  }, [fakeItemsCount]);
  var showFakeItems = isLoading && !products.length;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.wrapper, showFakeItems ? 'MarketplaceProductsList.Loading' : ''),
    maxWidth: 1240,
    mx: [1, 'auto'],
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    color: "text.main"
  }, wrapperProps), showFakeItems ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderFakeItem && renderFakeItem(), fakeProducts.map(function (fakeItem) {
    return renderFakeProduct(_objectSpread({
      id: fakeItem
    }, skeletonProps));
  })) : products.map(renderItem));
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceProductsList);

exports["default"] = _default;